import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGrubhubComponent } from './simple-icons-grubhub.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGrubhubComponent ],
    exports:      [ SimpleIconsGrubhubComponent ],
    bootstrap:    []
})
export class SimpleIconsGrubhubModule {}
